import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Button,
  Spinner,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import axios from '../../axiosConfig';

const Resources = () => {
  const { t } = useTranslation();
  const [articles, setArticles] = useState(null);

  useEffect(() => {
    axios
      .get('/articles?category=resource&random=true')
      .then((res) => setArticles(res.data))
      .catch((err) => console.error('Failed to fetch articles:', err));
  }, []);

  return (
    <Box
        id="resources"
        bgGradient="linear(to-r, rgba(229, 146, 59, 0.9), rgba(229, 146, 59, 0.9))"
        bgBlendMode="overlay"
        bgAttachment="fixed"
        backgroundSize="cover"
        py={20}
        color="#333"
      >
      <Container maxW="container.lg" fontSize="xl">
        <Heading as="h2" textAlign="center">
          {t('website.mainContent.resources.heading')}
        </Heading>
        <Text mt={4} textAlign="center">
          {t('website.mainContent.resources.teaser')}
        </Text>

        <Box mt={8} display="flex" justifyContent="center" flexWrap="wrap" gap={6}>
          {!articles ? (
            <Spinner size="xl" />
          ) : (
            articles.map((article) => (
              <Box
                key={article.id}
                w="300px"
                bg="white"
                boxShadow="md"
                borderRadius="md"
                overflow="hidden"
                border="0"
                transition="transform 0.2s, box-shadow 0.2s"
                _hover={{ transform: 'scale(1.03)', boxShadow: 'lg' }}
              >
                <Image
                  src={article.image_url}
                  alt={article.title}
                  objectFit="cover"
                  h="180px"
                  w="100%"
                />
                <Box p={4}>
                  <Heading as="h3" size="md" mb={2}>
                    {article.title}
                  </Heading>
                  <Text noOfLines={3} fontSize="sm" color="gray.600" dangerouslySetInnerHTML={{
                    __html: article.content.replace(/<[^>]+>/g, '') // strip HTML
                  }} />
                  <Box mt={4} textAlign="right">
                    <Button
                      as="a"
                      href={`/article/${article.slug}`}
                      size="sm"
                      colorScheme="orange"
                      variant="outline"
                    >
                      {t('website.mainContent.resources.cards.schoolEffectivenessSurvey.readMoreButton')}
                    </Button>
                  </Box>
                </Box>
              </Box>
            ))
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default Resources;